import { render, staticRenderFns } from "./BannerStudio.vue?vue&type=template&id=8b1289a4&scoped=true&"
import script from "./BannerStudio.vue?vue&type=script&lang=js&"
export * from "./BannerStudio.vue?vue&type=script&lang=js&"
import style0 from "./BannerStudio.vue?vue&type=style&index=0&id=8b1289a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1289a4",
  null
  
)

export default component.exports